<template>
    <v-container class="co-resumo">
        <v-col class="resumo">
            <v-card-text class="resumo-itens">
                <v-row no-gutters pb-3>
                    <div class="primary--text lighten-1 titulo pb-3">RESUMO</div>
                </v-row>

                <card-resumo-item
                    v-if="!!this.planoSelecionado"
                    :produto="this.planoSelecionado"
                    class="pb-2"
                />

                <card-resumo-item
                    v-for="adicional in Object.keys(itensAdicionais)"
                    v-if="itensAdicionais[adicional].quantidade > 0"
                    :key="itensAdicionais[adicional].nome"
                    :produto="itensAdicionais[adicional]"
                    class="pb-2"
                />

                <span v-if="!!cupomAplicado" class="cupom-text primary--text lighten-1 d-flex justify-space-between">
                    <p class="ma-0">Cupom aplicado: </p>
                    <span class="total">- {{ formatReal(valorDesconto) }}</span>
                </span>
            </v-card-text>

            <v-card-actions class="acoes d-block">
                <v-divider/>

                <p class="valor-final primary--text lighten-1">Total: <span
                    class="total">{{ formatReal(valorTotalItens) }}</span>
                </p>

                <v-btn :disabled="!ehPagamentoSelecionado"
                       block
                       class="confirmar-actions__btn"
                       color="green white--text"
                       depressed
                       @click="confirmar">
                    CONFIRMAR
                </v-btn>
            </v-card-actions>
        </v-col>
    </v-container>
</template>

<script>
import CardResumoItem from './CardResumoItem'

export default {
    name: 'Resumo',
    components: {CardResumoItem},
    props: {
        metodoSelecionado: {
            type: Object,
        },
        itensAdicionais: {
            type: Object,
        },
        planoSelecionado: {
            type: Object,
        },
        valorTotalItens: {
            type: Number
        },
        cupomAplicado: {
            type: Object
        },
        valorDesconto: {
            type: Number
        }
    },
    computed: {
        ehPagamentoSelecionado() {
            return !!this.metodoSelecionado
        },
    },
    methods: {
        confirmar() {
            if (this.valorTotalItens < 5) {
                this.mostrarNotificacaoErro("Valor total não pode ser menor que R$ 5,00.")
                return
            }
            this.$emit('confirmar-compra')
        },
        formatReal(valor) {
            if (valor < 0) {
                valor = 0
            }

            return valor.toLocaleString('pt-br', {style: 'currency', currency: 'BRL', minimumFractionDigits: 2})
        },
    }
}
</script>

<style lang="stylus">
.co-resumo
    background-color var(--background-400) !important
    display flex

    .resumo
        justify-content space-between
        padding 0
        position relative

        .resumo-itens
            overflow-y auto
            height calc(100% - 99px)
            padding-bottom 0

            .cupom-text
                font-size 12px
                margin 0

        .valor-final
            text-align center
            margin 10px

            .total
                font-size 20px

        .acoes
            position absolute
            width 100%
            bottom 0
            padding 6px

            &__btn
                height 40px

@media (max-width: 600px)
    .co-resumo
        .resumo
            .resumo-itens
                overflow-y unset
                height unset
                padding-bottom 105px

            .acoes
                position fixed
                background-color var(--background-400)

</style>
